import { Link, useLocation } from "react-router-dom";
import Button from "./ui/Button";
import logo from "../assets/groundwork-tierup-wordmark.png";
import { useAnalyticsPageview } from "../hooks/useAnalyticsPageview";

const NAV_LINKS = [
  { label: "Product Overview", href: "/tierup" },
  { label: "Charter", href: "/charter" },
  { label: "Delay Cost Calculator", href: "/calculator" },
  { label: "Pricing", href: "/pricing" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

const FOOTER_LINKS = [
  { label: "Pricing", href: "/pricing" },
  { label: "Charter", href: "/charter" },
];

const LEGAL_LINKS = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Cancellation Policy", href: "/cancellation" },
];

function Header() {
  const location = useLocation();

  return (
    <header
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
        padding: "14px 32px",
        borderBottom: "1px solid var(--border)",
        position: "sticky",
        top: 0,
        background: "rgba(255, 255, 255, 0.92)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        zIndex: 50,
      }}
    >
      <Link to="/" style={{ display: "flex", alignItems: "center" }}>
        {/* Sized for legibility, not just brand-mark presence: the wordmark carries a
            small script "TierUp" line under the caps that turns to mush much below this
            height. */}
        <img src={logo} alt="Groundwork TierUp" style={{ height: 40, width: "auto", display: "block" }} />
      </Link>

      <nav style={{ display: "flex", flexWrap: "wrap", rowGap: 6, columnGap: 24, fontSize: 14 }}>
        {NAV_LINKS.map((link) => {
          const active = location.pathname === link.href;
          return (
            <Link
              key={link.href}
              to={link.href}
              style={{
                color: active ? "var(--lilac-deep)" : "var(--text-secondary)",
                fontWeight: active ? 600 : 500,
                whiteSpace: "nowrap",
                transition: "color var(--transition-fast)",
              }}
            >
              {link.label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}

function Footer() {
  return (
    <footer
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        padding: "28px 32px",
        marginTop: 60,
        borderTop: "1px solid var(--border)",
        background: "var(--surface-1)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
        <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: 0 }}>
          Built by a 20-year practitioner.{" "}
          <Link to="/about" style={{ color: "var(--lilac-deep)", fontWeight: 600 }}>
            Read the story &rarr;
          </Link>
          {" "}&middot;{" "}
          <a href="https://groundwork-tierup.kit.com" target="_blank" rel="noopener noreferrer" style={{ color: "var(--lilac-deep)", fontWeight: 600 }}>
            Get Field Notes in your inbox &rarr;
          </a>
        </p>
        <Button href="https://groundworktierup.app/?intent=register" external variant="secondary" size="sm" style={{ fontWeight: 600 }}>
          Start something new
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
          paddingTop: 16,
          borderTop: "1px solid var(--border-strong)",
        }}
      >
        <p style={{ fontSize: 12, color: "var(--text-muted)", margin: 0 }}>
          Groundwork TierUp &middot; ABN 16 442 280 390
        </p>
        <nav style={{ display: "flex", flexWrap: "wrap", gap: 18, fontSize: 12 }}>
          {[...FOOTER_LINKS, ...LEGAL_LINKS].map((link) => (
            <Link key={link.href} to={link.href} style={{ color: "var(--text-muted)" }}>
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}

export default function Layout({ children }) {
  useAnalyticsPageview();
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Header />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </div>
  );
}
